import { FC } from "react";
import { unconfirmedCopy } from "@1-now/booking-core";
import type { Unconfirmed } from "@1-now/booking-core";

/**
 * After a charge whose answer never came: what is known, and a way to check.
 * A status region under the Pay button it has locked, not a toast — this is a
 * question about money that is still open. The words are the package's, the
 * same on every checkout.
 */
const UnconfirmedNotice: FC<{
  state: Unconfirmed;
  checking: boolean;
  onCheck: () => void;
}> = ({ state, checking, onCheck }) => {
  const copy = unconfirmedCopy(state);
  return (
    <div
      role="status"
      className="mt-4 text-yellow-600 dark:text-yellow-500 p-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg"
    >
      <p className="font-semibold">{copy.title}</p>
      <p className="text-sm mt-1">{copy.body}</p>
      {copy.canCheck && (
        <button
          type="button"
          onClick={onCheck}
          disabled={checking}
          className="mt-2 text-sm font-semibold underline disabled:opacity-60"
        >
          {checking ? "Checking…" : "Check payment status"}
        </button>
      )}
    </div>
  );
};

export default UnconfirmedNotice;
